<template>
  <div class="main-container">

    <div class="container">
      <div v-if="optional_data.get != ''">
        <div v-if="optional_data.get.grand_prize_pools.length > 0">
          <h2>Grand Prize Selection</h2>
          <div class="clearfix font-size-24 text-upper-case text-align-center">
            <div :id="'grand_prize_pools-'+pool.name" data-grand_prize_pools class="" v-for="(pool,i) in optional_data.get.grand_prize_pools" @click="post_request({selected_pool_id: pool.id})"> {{pool.name}} 
            </div>
          </div>

        </div>

        <div v-if="optional_data.get.sweeps_prize_pools.length > 0">
          <h2>Sweepstakes Selection</h2>
          <div class="clearfix font-size-24 text-upper-case text-align-center">
            <div :id="'sweeps_prize_pools-'+pool.name" data-sweeps_prize_pools v-for="(pool,i) in optional_data.get.sweeps_prize_pools" @click="post_request({selected_pool_id: pool.id})"> 
              {{pool.name}} 
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
    import {computed_values} from '../mixins/computed_values'
    import {post_request, requests_methods, validation} from "../mixins/requests";
    import {elements_classes} from '../mixins/elements_classes'

    export default {
        name: "sweepstakes_selection",
        mixins: [post_request, requests_methods, computed_values, validation, elements_classes],
        data(){
            return{
                // this_page: 'sweepstakes_selection'
            }
        },
        computed: {
            this_page(){
                return this.$route.name
            }
        }
    }
</script>

<style scoped>
</style>